export default function Financing() {
  const options = [
    {
      title: 'Cash Purchase',
      copy: 'Maximum long-term return. Own the system outright and capture every incentive available.',
      meta: 'Best lifetime savings',
    },
    {
      title: 'Solar Loan',
      copy: 'Fixed monthly payments, often lower than your current utility bill. Full system ownership.',
      meta: 'Predictable monthly cost',
    },
    {
      title: 'Lease / PPA',
      copy: 'No upfront cost. Pay only for the clean electricity produced, at a rate below the grid.',
      meta: 'Zero-down entry',
    },
  ];

  return (
    <section id="financing" className="py-[64px] md:py-[120px] bg-white">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-6 mb-10 md:mb-16">
          <div className="col-span-12 md:col-span-6">
            <p className="text-xs font-medium text-solar-green tracking-wider uppercase">Financing</p>
            <h2 className="display-font mt-4 text-[34px] md:text-[48px] font-semibold leading-[1.05] text-solar-ink">
              Three ways in.<br/>All designed to save.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 flex items-end justify-end">
            <div className="inline-flex items-center gap-3 px-4 py-3 rounded-xl" style={{ backgroundColor: '#FFC905' }}>
              <i className="ri-price-tag-3-line text-solar-ink"></i>
              <span className="text-solar-ink text-sm font-semibold">$0 down options available</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {options.map((o) => (
            <div key={o.title} className="group border border-solar-divider rounded-2xl p-8 bg-white hover:border-solar-ink hover:bg-solar-bg/40 hover:-translate-y-1 transition-all duration-300 ease-out cursor-pointer">
              <p className="text-xs font-medium text-solar-muted tracking-wide">{o.meta}</p>
              <h3 className="display-font mt-3 text-[24px] md:text-[26px] font-semibold text-solar-ink transition-colors duration-300 group-hover:text-black">
                {o.title}
              </h3>
              <p className="mt-4 text-solar-muted text-[14px] leading-relaxed">{o.copy}</p>
              <span className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-solar-ink">
                See details
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1.5"></i>
              </span>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-10 border-t border-solar-divider grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 text-sm text-solar-muted">
          <div>
            <p className="text-solar-ink font-semibold mb-1">Federal Tax Credit</p>
            <p>Currently 30% of total installed system cost, applied against federal income tax.</p>
          </div>
          <div>
            <p className="text-solar-ink font-semibold mb-1">State & Utility Incentives</p>
            <p>Additional rebates, performance payments and net-metering credits vary by region.</p>
          </div>
          <div>
            <p className="text-solar-ink font-semibold mb-1">Commercial Depreciation</p>
            <p>MACRS accelerated depreciation available for qualifying commercial installations.</p>
          </div>
        </div>
      </div>
    </section>
  );
}